import { useContext, useEffect, useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { useForm } from 'react-hook-form'
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from 'react-query'
import { SchemaValidation } from "../services/schemaValidation";
import { ValidateErrorMessage } from "components/ValidateErrorMessage";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { edit } from "../services/api";
import { useTranslation } from "react-i18next";
import FormBuilder from "components/Inputs/FormBuilder";
import { DataFields } from "../Add/DataFields";
import { isEmptyObject } from "helpers";
import { AuthContext } from "context/AuthContext";
import ImageManager from "components/ImageManager";

export default function Edit({ open, close, instance, reportAction }) {
  const { t } = useTranslation();
  const { setUdateBranchOfficeSelected } = useContext(AuthContext)
  const globalUser = JSON.parse(localStorage.getItem('mqadusr'))
  const [isLoading, setIsLoading] = useState(false)
  const [dataInstance, setDataInstance] = useState({})
  const [imageManagerModalOpen, setImageManagerModalOpen] = useState(false)
  const [dataFieldImageManager, setDataFieldImageManager] = useState(null)
  let { reset, handleSubmit, register, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(SchemaValidation(t))
  })

  useEffect(() => {
    if (open) {
      delete instance.logo
      setDataInstance(instance)
      reset(instance)
    }
  }, [open])

  const mutation = useMutation(edit, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        reportAction(false, 'Error al guardar los datos', 'error')
      } else {
        setUdateBranchOfficeSelected(new Date())
        reportAction(true, 'Acción realizada correctamente', 'success')
      }
    }
  })

  const handleEdit = (params) => {
    let id = params._id
    delete params._id
    delete params.deleted
    delete params.createdAt
    delete params.updatedAt
    delete params.deletedAt
    const formData = new FormData()
    for (const key in params) {
      if (key === "logo") {
        if (Array.isArray(params.logo)) {
          formData.append("logo", params.logo[0].file)
        }
      } else {
        formData.append(key, params[key])
      }
    }
    setIsLoading(true)
    mutation.mutate({ id, params: formData })
  }

  const handleClose = () => { reset(); setDataInstance({}); close() }

  const handleOnChangeData = (event) => {
    if (event.target.name.includes(".")) {
      const separate = event.target.name.split(".")
      setDataInstance({ ...dataInstance, [separate[0]]: { ...dataInstance[separate[0]], [separate[1]]: event.target.value } })
      return;
    }
    setDataInstance({ ...dataInstance, [event.target.name]: event.target.value })
  }

  const handleChangeBoolean = (name) => {
    setDataInstance({ ...dataInstance, [name]: !dataInstance[name] })
  }

  /*Handlers Image manager */
  const handleOpenImageManager = () => { setImageManagerModalOpen(true) }
  const handleCloseImageManager = (prop) => { setImageManagerModalOpen(prop) }
  const handleFieldImageManager = (prop) => { setDataFieldImageManager(prop) }
  const handleSelectImageManager = (url) => {
    setDataInstance({ ...dataInstance, [dataFieldImageManager]: url })
    setValue(dataFieldImageManager, url)
  }

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t("button_text_cancel")}</Button>
      <Button variant="contained" color="info" onClick={handleSubmit(handleEdit)} disabled={isEmptyObject(dataInstance)}>{t("button_text_edit")}</Button>
    </> : <CircularProgress />}
  </>)

  return (<>
    <FlexibleWidthDialog open={open} title={t('branchoffice_dialog_title_edit')} actions={<Actions />}>
      <>
        <input type="hidden" name="company" {...register(`company`)} value={globalUser.company._id} />
        <ValidateErrorMessage message={errors.menu?.message} />
        <FormBuilder
          dataDields={DataFields(t)}
          dataInstance={dataInstance}
          register={register}
          errors={errors}
          changeDataFunction={handleOnChangeData}
          changeDataBoolean={handleChangeBoolean}
          openImageManager={handleOpenImageManager}
          setFieldImageManager={handleFieldImageManager} />
      </>
    </FlexibleWidthDialog>
    <ImageManager
      open={imageManagerModalOpen}
      actionClose={handleCloseImageManager}
      multipleImages={false}
      setImages={handleSelectImageManager} />
  </>)
}